import { useTranslation } from 'react-i18next'
import { SEO } from '@/components/SEO'
import { HeroSection } from './HeroSection'
import { CultureSection } from './CultureSection'
import { JobApplicationForm } from './JobApplicationForm'
import { ContactSection } from './ContactSection'

export function CareersPage() {
  const { t } = useTranslation('common')

  return (
    <>
      <SEO
        title={t('nav.workWithUs')}
        description={t('careers.metaDescription')}
        type="website"
      />

      <main id="main-content">
        <HeroSection />
        <JobApplicationForm />
        <CultureSection />
        <ContactSection />
      </main>
    </>
  )
}
